/* One Kickz: el popup se muestra UNA sola vez por navegador (se cierre como se cierre). */
const OK_NEWSLETTER_SEEN_KEY = "ok_newsletter_seen";

function okNewsletterWasSeen() {
  try {
    if (localStorage.getItem(OK_NEWSLETTER_SEEN_KEY)) return true;
  } catch (e) {}
  return getCookie("ok-newsletter-seen") === "true";
}

function okNewsletterMarkSeen() {
  try {
    localStorage.setItem(OK_NEWSLETTER_SEEN_KEY, String(Date.now()));
  } catch (e) {}
  // Cookie de respaldo por 1 anio
  document.cookie = "ok-newsletter-seen=true; max-age=31536000; path=/; SameSite=Lax";
}

class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    okNewsletterMarkSeen();
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (okNewsletterWasSeen()) return;

    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (okNewsletterWasSeen()) return;
      if (this.closed !== "true" && this.subscribed !== "true") {
        okNewsletterMarkSeen();
        this.show();
      }
    }, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    okNewsletterMarkSeen();
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
